import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { UzurvDirectivesModule } from '@uzurv/core';
import { MaterialModule } from './../../../app/material.module';
import { RideStatusChipModule } from './../../ride-status-chip/ride-status-chip.module';
import { AdjustReservationStatusDialogComponent } from './adjust-reservation-status-dialog.component';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, MaterialModule, RideStatusChipModule, UzurvDirectivesModule],
  declarations: [AdjustReservationStatusDialogComponent],
  exports: [AdjustReservationStatusDialogComponent]
})
export class AdjustReservationStatusDialogModule {}
